import app from '@/app';
import templateUrl from './decision-tree-node.html';
import {getTranslate} from "@/app/shared/translate-helper";

/* @ngInject */
function DecisionTreeNodeController(Organization, Road, $http) {
	var $ctrl = this;
  
	$ctrl.isPaving = false;
	$ctrl.organizations = [];
	$ctrl.roadsByNode = new Map();
 
	$ctrl.$onInit = () => {
		$ctrl.allMetrics = $ctrl.allMetrics.filter(item => item.code != 'KPI_INTERVENTION_YEAR');
		$ctrl.model = $ctrl.model || {
			type: 'GROUP',
			operator: 'OR',
			items: []
		};
		$ctrl.allPavingTypes = [];

		$ctrl.loadOrganizations();
		$ctrl.initializeExistingRoadNodes();
	};

	$ctrl.loadOrganizations = () => {
		Organization.query({ size: 1000 }).$promise.then(res => {
			$ctrl.organizations = res.content || res;
		});
	};

	$ctrl.initializeExistingRoadNodes = () => {
		$ctrl.model.items.forEach(node => {
			if (node.lhsMetric === 'KPI_ROAD' && node.rhsValue) {
				// If we have a road ID, we need to find its organization to pre-select it
				Road.get({ id: node.rhsValue }).$promise.then(road => {
					node.organizationId = road.owner.id;
					$ctrl.fetchRoads(node);
				});
			}
		});
	};

	$ctrl.pavingTypes = [1, 2, 3, 4];
	$ctrl.directions = [
		{ value: 1, label: 'direction.INC' },
		{ value: 2, label: 'direction.DEC' },
		{ value: 3, label: 'direction.BOTH' }
	];


	$ctrl.translatePavingType = value => {
		if (value) {
			switch (value) {
				case 1:
					return getTranslate().instant('decision_tree_node.flexible');
				case 2:
					return getTranslate().instant('decision_tree_node.semi_rigid');
				case 3:
					return getTranslate().instant('decision_tree_node.inverted_semi_rigid');
				case 4:
					return getTranslate().instant('decision_tree_node.rigid');
				case '1':
					return getTranslate().instant('decision_tree_node.flexible');
				case '2':
					return getTranslate().instant('decision_tree_node.semi_rigid');
				case '3':
					return getTranslate().instant('decision_tree_node.inverted_semi_rigid');
				case '4':
					return getTranslate().instant('decision_tree_node.rigid');
				default: return getTranslate().instant('decision_tree_node.unidentified');
			}
		}
	};

	$ctrl.onLhsMetricChange = (node) => {
		$ctrl.isPaving = $ctrl.model.items.some(item => item.lhsMetric === 'PAVING_TYPE');
		node.rhsValue = undefined;
		node.rhsMetric = undefined;
		node.organizationId = undefined;
		if (node.lhsMetric === 'PAVING_TYPE' || node.lhsMetric === 'KPI_DIRECTION' || node.lhsMetric === 'KPI_ROAD' || node.lhsMetric === 'KPI_LANE') {
			node.operator = 'EQ';
		}
	};

	$ctrl.onOrganizationChange = (node) => {
		node.rhsValue = undefined;
		if (node.organizationId) {
			$ctrl.fetchRoads(node);
		} else {
			$ctrl.roadsByNode.delete(node);
		}
	};

	$ctrl.fetchRoads = (node) => {
		$http.get('/api/roads/summary', { params: { organizationId: node.organizationId } }).then(res => {
			$ctrl.roadsByNode.set(node, res.data);
		});
	};

	$ctrl.onRhsMetricChange = node => {
		if (node.rhsMetric) {
			node.rhsValue = undefined;
		}
	};

	$ctrl.getFactor = code => code ? $ctrl.allMetrics.find(item => item.code == code).factor : 1;

	$ctrl.addItem = () => {
		$ctrl.model.items.push({ type: 'SINGLE' });
	};

	$ctrl.removeNode = node => {
		$ctrl.model.items = $ctrl.model.items.filter(item => item != node);
		$ctrl.isPaving = $ctrl.model.items.some(item => item.lhsMetric === 'PAVING_TYPE');
		$ctrl.roadsByNode.delete(node);
	};
}

const component = {
	templateUrl,
	controller: DecisionTreeNodeController,
	bindings: {
		model: '=',
		allMetrics: '<'
	}
};

app.component('prDecisionTreeNode', component);
